import { FC, useMemo } from 'react'
import IllustrationGrid, {
  IllustrationGridProps,
} from 'src/components/IllustrationGrid'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'
import { ActionIconBackground } from '../../../components/ActionButton/types'
import { getThemeColor } from '../../Transformers/ThemeTransformer'
import { colors } from '../../../theme'

import { ImageGalleryBlockProps } from './props'

const ImageGalleryBlock: FC<BlockProps<ImageGalleryBlockProps>> = ({
  data,
  configuration,
  locale,
}) => {
  const props: IllustrationGridProps = useMemo(() => {
    const captions = data.imagesCaptions
      ? data.imagesCaptions.split('\n').filter((caption) => !!caption)
      : []
    return {
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.sectionTitle && {
            tag: data.sectionTitle,
          }),
          color: getThemeColor(data.theme?.data) ?? colors.blueLight,
        },
      }),
      illustrations:
        // v4 wraps media as `images.data[]`; v5 returns a flat array.
        ((data?.images as any)?.data ?? data?.images ?? []).map(
          (imageRaw: any, index: number) => {
            const attrs: any = imageRaw?.attributes ?? imageRaw
            const imageProps = ImageTransformer(imageRaw)
            return {
              caption: captions?.[index] || attrs?.caption || '',
              ...(imageProps && { pictureProps: { imageProps } }),
            }
          }
        ),
      ...(data.cta && {
        actionButtonProps: ButtonTransformer({
          data: data.cta,
          theme: data.theme?.data,
          forceColor: colors.blueLight,
          iconBackground: ActionIconBackground.color,
        }),
      }),
      ...(data.description && {
        richTextProps: RichTextTransformer(
          data.description,
          configuration,
          locale
        ),
      }),
    }
  }, [
    configuration,
    data.cta,
    data.description,
    data?.images,
    data.imagesCaptions,
    data.sectionTitle,
    data.theme?.data,
    data.title,
    locale,
  ])

  return <IllustrationGrid {...props} />
}

export default ImageGalleryBlock
